import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import instance from 'api/v1'
import { useAuth } from 'hooks/useAuth'
import { createSnackbar } from 'utils/createSnackbar'

export const useCreateProgram = () => {
  const navigate = useNavigate()
  // @ts-ignore
  const { user } = useAuth()
  const apiInstance = instance(user)

  return useCallback((state: any) => {
    const fetch = async () => {
      await apiInstance.post('/programs', state, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(() => {
          createSnackbar('Program created successfully')
          navigate('/programs')
        })
        .catch((error) => {
          console.error(error)
          if (error.response) createSnackbar(error.response.data.message)
          else createSnackbar('Something went wrong')
        })
    }
    fetch()
  }, [])
}
